// extracted by mini-css-extract-plugin
export default {"container":"QjB2wK2Rn2hJYrqDGzyjU","icon":"_2xv08UMeXX0W4urdSltPSM","row":"_1bvHOZRuPRWr10YLeRdr7n","label":"_1cKv7pKauig81uREbND6ue","pricingInfo":"_30dERJG6YsaofVxzo3meH"};